import { Box, Switch, Tooltip } from '@optiaxiom/react';

import type { ToolChatToggleProps } from './types';

export function ToolChatToggle({ tool, onToggleEnabledInPrimaryAgent }: ToolChatToggleProps) {
  const isAlwaysOn = tool.always_on_in_primary_agent;
  const isDisabled = tool.is_disabled || isAlwaysOn;

  const switchComponent = (
    <Switch
      disabled={isDisabled}
      checked={tool.is_enabled_in_primary_agent}
      onCheckedChange={checked => onToggleEnabledInPrimaryAgent(tool.name, !checked)}
      aria-label={`Toggle ${tool.name} enabled in primary agent`}
    />
  );

  if (isAlwaysOn) {
    return (
      <Tooltip content="This tool is always enabled and cannot be disabled as it's required for the primary agent to function correctly.">
        <Box display="inline-flex">{switchComponent}</Box>
      </Tooltip>
    );
  }

  return switchComponent;
}
